import * as React from 'react';

import { Alert, AlertInputIcon, AlertInlineAction } from '../../../../components/Alert';
import { ADDRESS_HAS_MANY_CADASTRE_ALERT } from '../../const';

export interface IAddressHasManyCadastreAlertProps {
  onAction: () => void;
}

export const AddressHasManyCadastreAlert: React.FC<IAddressHasManyCadastreAlertProps> = ({ onAction }) => {
  const { title, actionText, actionTestId, message, testId } = ADDRESS_HAS_MANY_CADASTRE_ALERT;

  const userMessage = (
    <>
      <AlertInlineAction onClick={onAction} testId={actionTestId}>
        {actionText}
      </AlertInlineAction>
      {message}
    </>
  );

  return <Alert icon={<AlertInputIcon />} title={title} message={userMessage} testId={testId} />;
};
